import { SystemAdminUserInput, User } from '../../lib/types/models/users/user'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createUser(data: SystemAdminUserInput) {
  return restApiClient
    .url(constructApiUrl(API.user.create.url, null))
    .post<User, SystemAdminUserInput>(data)
}
